var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('el-button',{directives:[{name:"loading",rawName:"v-loading.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"lock":true}}],staticClass:"btn"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }